import { useState } from 'react';

import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

import Autoplay from '@webclient/components/search-forms/gamification-search/actions/filters/autoplay';
import ResponseLength from '@webclient/components/search-forms/gamification-search/actions/filters/response-length';
import StyledIconButton from '@webclient/components/search-forms/gamification-search/actions/filters/styles';
import Thoughfulness from '@webclient/components/search-forms/gamification-search/actions/filters/thoughtfulness';

import useAppSettingsModal from '@webclient/hooks/useAppSettingsModal';

import SettingRoundedIcon from '~icons/knowz-iconify/settings';
import SlidersRoundedIcon from '~icons/knowz-iconify/sliders';

import { IconButton } from '@knowz/knowz-ui';

type Props = {
  controls?: {
    responseLength: boolean;
    thoughtfulness: boolean;
    autoplay: boolean;
  };
};

export default function Filters({ controls }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const {
    autoplay = true,
    responseLength = true,
    thoughtfulness = true,
  } = controls || {};

  const open = Boolean(anchorEl);
  const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { toggleAppSettingsModal } = useAppSettingsModal();

  return (
    <Box>
      <IconButton
        variant="ghost"
        color="secondary"
        size="small"
        onClick={handleOpenPopover}
      >
        <SlidersRoundedIcon />
      </IconButton>
      <Popover
        slotProps={{
          paper: {
            sx: {
              position: 'relative',
              width: { xs: 370, sm: 480 },
              backgroundColor: 'utility.brand50Alt',
              padding: (theme) => theme.spacing(6, 5),
            },
          },
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        anchorOrigin={{
          horizontal: 'center',
          vertical: -30,
        }}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
      >
        <StyledIconButton
          onClick={toggleAppSettingsModal}
          variant="ghost"
          color="secondary"
          shape="fullRounded"
          size="small"
        >
          <SettingRoundedIcon />
        </StyledIconButton>
        <Stack gap={6}>
          {responseLength && <ResponseLength />}
          {thoughtfulness && <Thoughfulness />}
          {/* {searchMode === 'advanced' && <ResearchTime />} /* TODO: we add this back once it is handled in AI server */}
          {autoplay && <Autoplay />}
        </Stack>
      </Popover>
    </Box>
  );
}
